<div class="tooltip" *ngIf="active">
    <div class="arrow"></div>
    <div class="content">{{description}}</div>
    <figure class="icon-container">
        <img class="icon-element" (click)="close()" [ngSrc]="'icons/close.svg' | staticServe" width="20" height="20" alt="">
    </figure>
</div>